import { ChevronDown, ChevronUp } from 'lucide-react';
import React from 'react';

import { toolbarTabStyle } from './toolbar-styles';

export type ToolbarCollapseTabProps = {
	isCollapsed: boolean;
	onToggle: () => void;
};

/** One affordance in two states: the tab that hides the toolbar and the tab that brings it back */
export const ToolbarCollapseTab = (props: ToolbarCollapseTabProps): React.ReactElement => {
	const { isCollapsed, onToggle } = props;

	return (
		<button
			type="button"
			onClick={onToggle}
			title={isCollapsed ? 'Show the annotations toolbar' : 'Hide the annotations toolbar'}
			style={toolbarTabStyle(isCollapsed)}
		>
			{isCollapsed ? <ChevronDown size={13} /> : <ChevronUp size={13} />}
			{isCollapsed ? 'Annotations' : 'Hide'}
		</button>
	);
};
